import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	triggerButton: {
		id: 'native-issue-table.common.issue-cells.labels.trigger-button',
		defaultMessage: 'See more labels',
		description: 'Label for trigger button to open a dialog with a list of labels',
	},
});
